"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18nResources = exports.EN = void 0;
const en_1 = __importDefault(require("./en"));
exports.EN = en_1.default;
exports.i18nResources = {
    en: {
        translation: en_1.default
    }
};
